import React, { useMemo } from "react";
import { Form } from "antd";
import { Select } from "./BaseSelect";
import { observer } from "mobx-react-lite";
import { useGlobalStore } from "@/store/hooks";

interface AddressFieldProps {}

const AddressField: React.FC<AddressFieldProps> = function (props) {
    const globalStore = useGlobalStore();

    const provinceOptions = useMemo(
        () =>
            globalStore.areaStore.fhyAreas.map((province) => {
                const { id, name } = province;
                return { value: id, key: id, label: name };
            }),
        [globalStore.areaStore.fhyAreas],
    );

    return (
        <>
            <Form.Item label={<span className="search-field-label">收货省份</span>} name="provinceCode" initialValue="">
                <Select
                    showSearch={{
                        optionFilterProp: "label",
                    }}
                    onOpenChange={globalStore.areaStore.ensureFhyArea}
                    options={[
                        {
                            value: "",
                            label: "- 选择省份 -",
                        },
                        ...(provinceOptions ?? []),
                    ]}
                />
            </Form.Item>
            <Form.Item shouldUpdate noStyle>
                {(form) => {
                    const { provinceCode } = form.getFieldsValue();

                    function buildOptions() {
                        const cities = globalStore.areaStore.fhyAreaMap.get(provinceCode)?.children;

                        if (cities?.length) {
                            return cities.map((city) => {
                                const { id, name } = city;

                                return { value: id, key: id, label: name };
                            });
                        }

                        return null;
                    }

                    return (
                        <Form.Item
                            label={<span className="search-field-label">收货城市</span>}
                            name="cityCode"
                            initialValue=""
                        >
                            <Select
                                showSearch={{
                                    optionFilterProp: "label",
                                }}
                                options={!provinceCode ? [] : buildOptions() ?? []}
                            />
                        </Form.Item>
                    );
                }}
            </Form.Item>
        </>
    );
};

export default observer(AddressField);
